import { FC, useCallback } from "react";
import { resourceExplorerCostTypeSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data/resourceExplorerCostTypeSelector";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { CostType } from "@/services/cloudchipr.api";
import { setResourceExplorerCostType } from "@/store/resource-explorer/resourceExplorerSlice";
import { resourceExplorerPathLastItemFilterTreeSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/path/resourceExplorerPathLastItemFilterTreeSelector";
import { getResourceExplorerDataThunk } from "@/store/resource-explorer/thunks/widgets/getResourceExplorerDataThunk";
import { CostTypeSelect } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/CostTypeSelect";

interface ViewCostTypeSelectProps {
  variant?: "dropDown" | "select";
}
export const ViewCostTypeSelect: FC<ViewCostTypeSelectProps> = ({
  variant,
}) => {
  const dispatch = useAppDispatch();

  const selectedCostType = useAppSelector(resourceExplorerCostTypeSelector);

  const pathLastItemFilterTree = useAppSelector(
    resourceExplorerPathLastItemFilterTreeSelector,
  );

  const handleChange = useCallback(
    (costType: CostType) => {
      dispatch(setResourceExplorerCostType(costType));
      dispatch(getResourceExplorerDataThunk(pathLastItemFilterTree));
    },
    [dispatch, pathLastItemFilterTree],
  );

  return (
    <CostTypeSelect
      costType={selectedCostType ?? "unblended"}
      onCostTypeChange={handleChange}
      variant={variant}
    />
  );
};
